import AuthHeader from "components/AuthHeader";
import NonAuthLayoutWrapper from "components/NonAutnLayoutWrapper";
import { useRedux } from "hooks";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { APIClient } from "../../api/apiCore";
import { setActiveMemberrole, setActivePostId2 } from "../../redux/workplace/wpActions";

import {
    getChatUserDetails2s
    , readConversation, getChatUserConversations2, changeSelectedChat
    , setActiveGroupId
    , changeTab
} from "../../../src/redux/actions";
import { TABS, WpModes } from "../../constants/layout";
import { createSelector } from "reselect";
import { MemberRole, WpSliceData } from "../../redux/workplace/wpTypes";
import { SKeys } from "const";
import { Utils } from "helpers/utils";

const DirectRedirection = () => {
    const { dispatch, useAppSelector } = useRedux();
    const storeData = createSelector(
        (state: any) => state.WpSlice,
        (state: any) => state.Layout,
        (wp: WpSliceData, ly: any) => ({
            activeMemberRole: wp.activeMemberRole,
            activeTab: ly.activeTab,
        })
    );
    const { activeMemberRole, activeTab } = useAppSelector(storeData);
    const [redirectUrl, setRedirectUrl] = useState<string | null>(null);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const fnGoToWorkPlace = async (wpMode: WpModes, activePostId: string, memberRole: MemberRole) => {
            const tab = wpMode == WpModes.Workplace ? TABS.WORKPLACE : TABS.TASK;
            if (tab != activeTab || (activeMemberRole != memberRole && activeMemberRole != MemberRole.All)) { // 20250504 If already view all, then no need to change role
                await dispatch(setActiveMemberrole(wpMode, memberRole));
            }
            localStorage.setItem(SKeys.RedirectWpId, activePostId);
            //await dispatch(loadPostTitle("", [], memberRole, null, false, false, false)); // 20250610 seem in workplace core also call this function
            setTimeout(() => {
                dispatch(setActivePostId2(wpMode, activePostId, null, null, null, null, "Direct Redirection GoTo " + (wpMode == WpModes.Workplace ? "Workplace" : "Task")));
            }, 700);
        };

        // console.log('URL changed:', location.pathname);
        const queryParams = new URLSearchParams(location.search);
        const goToChat = queryParams.get('gtc');
        const goToWp = queryParams.get('wpc');
        const goToTask = queryParams.get('tkc');
        if (goToChat) { // open redirect with specific chat id
            const api = new APIClient();
            api.fnPostForm("/check-redirect-openchat", { userOrGroupId: goToChat })
                .then(response => {
                    const chatId = Number(goToChat);
                    dispatch(changeTab(TABS.CHAT));
                    dispatch(getChatUserDetails2s(chatId, true, true, false)); // 20250228 Load profile for able to get name when click from notification icon
                    dispatch(setActiveGroupId(chatId));
                    dispatch(changeSelectedChat(chatId));

                    setRedirectUrl(response.url);
                })
                .catch(err => {
                    setRedirectUrl("/auth-login");
                });
        } else if (goToWp || goToTask) {
            const postId = (goToWp ? goToWp : goToTask) ?? "";
            const api = new APIClient();
            api.fnPostForm("/check-redirect-openwp", { postIdParent: postId })
                .then(response => {
                    // console.log('check-redirect-openwp:', response);
                    if (response.msg) {
                        Utils.SweetAlert(response.msg).then(x => {
                            setRedirectUrl("/dashboard"); //20250826 go to home page instead    
                        });
                    } else {
                        if (goToWp) {
                            dispatch(changeTab(TABS.WORKPLACE));
                            fnGoToWorkPlace(WpModes.Workplace, postId, response.memberRole);
                            setRedirectUrl(response.url);
                        } else if (goToTask) {
                            dispatch(changeTab(TABS.TASK));
                            fnGoToWorkPlace(WpModes.Task, postId, response.memberRole);
                            setRedirectUrl(response.url);
                        }
                    }
                })
                .catch(err => {
                    // setRedirectUrl("/auth-login");
                    Utils.SweetAlert(Utils.GetMessageFromExecption(err)).then(x => {
                        setRedirectUrl("/dashboard"); //20250826 go to home page instead    
                    });
                    // setRedirectUrl("/dashboard"); //20250826 go to home page instead
                });
        } else {
            setRedirectUrl('/');
        }
    }, [location]);

    useEffect(() => {
        if (redirectUrl) {
            navigate(redirectUrl);
        }
    }, [redirectUrl]);

    return (
        <NonAuthLayoutWrapper>
            <Row className=" justify-content-center my-auto">
                <Col sm={8} lg={6} xl={5} className="col-xxl-4">
                    <div className="py-md-5 py-4">
                        <AuthHeader
                            title={"ยินดีต้อนรับสู่ " + process.env.REACT_APP_NAME}
                            subtitle="กำลังพาท่านไปสู้ส่วนที่ต้องการ"
                        />

                        <div className="mt-5 text-center text-muted">
                            <p>
                                <Link
                                    to="/auth-login"
                                    className="fw-medium text-decoration-underline"
                                >
                                    Login
                                </Link>
                            </p>
                        </div>
                    </div>
                </Col>
            </Row>
        </NonAuthLayoutWrapper>
    );
}

export default DirectRedirection;